export const Keywords = [
    'fn',
    'on',
    'if',
    'else',
    'do',
    'while',
    'for',
    'in',
    'break',
    'continue',
    'return',
    'true',
    'false',
    'null',
    'not',
    'this',
    'and',
    'or',
    'local',
    'public',
    'import',
    'wait',
    'new',
    'class',
    'extends',
    'parent',
] as const;
